import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    document: 'document',
    dropToUpload: 'Drop your {documentName} here',
    fileTypeError:
      'Unfortunately this type of file is not accepted. Please upload a {fileTypes}.',
    maxSizeError: 'This file is too large. The size limit is {maxSize}MB.',
    uploading: 'Uploading...',
  },
  fr: {
    document: 'document',
    dropToUpload: 'Déposez votre {documentName} ici',
    fileTypeError:
      'Malheureusement, ce type de fichier n’est pas accepté. Merci de réessayer avec un format {fileTypes}.',
    maxSizeError:
      'Ce document est trop lourd. La limite de taille est de {maxSize}MO.',
    uploading: 'En cours de téléchargement...',
  },
});

export default locales;
